// API配置文件
const config = {
  // API基础路径
  baseURL: process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'development' ? '/apiclouds' : '/apiclouds'),

  // 请求超时时间（毫秒）
  timeout: 10000,

  // 默认分页大小
  pageSize: 10,

  // 本地存储键名
  storageKeys: {
    authToken: 'authToken',
    userId: 'userId',
    browserId: 'browserId',
    userPhone: 'userPhone'
  }
};

export default config;
